import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetSecUsuario, IGetUsuarioBasico, IUsuario, RegistrarSecUsuarioRequest, RestablecerPasswordRequest, SolicitudRestablecerPasswordRequest, UsuarioActualizacionInfo, VwSecUsuario } from '../../shared/interfaces/database/seguridad';
import { ActivarUsuarioRequest } from '../../../../../tramitantes/src/app/shared/interfaces/seguridad';

@Injectable({
  providedIn: 'root'
})
export class SecUsuarioService {
  private readonly baseUrl = `${environment.apiUrl}/api/usuario`;

  constructor(private http: HttpClient) { }

  getUsuarios(): Observable<IGetSecUsuario[]> {
    return this.http.get<IGetSecUsuario[]>(`${this.baseUrl}`);
  }

  getUsuariosBasico(): Observable<IGetUsuarioBasico[]> {
    return this.http.get<IGetUsuarioBasico[]>(`${this.baseUrl}/basico`);
  }

  getUserByUsername(username: string): Observable<IUsuario> {
    return this.http.get<IUsuario>(`${this.baseUrl}/byUsername/${username}`);
  }

  updateUsuario(id: number, request: RegistrarSecUsuarioRequest): Observable<UsuarioActualizacionInfo[]> {
    return this.http.put<UsuarioActualizacionInfo[]>(`${this.baseUrl}/${id}`, request);
  }

  isCodigoActivacionValido(codigo: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}/public/is-codigo-activacion-valido/${codigo}`);
  }

  activarUsuario(request: ActivarUsuarioRequest): Observable<boolean> {
    return this.http.put<boolean>(`${this.baseUrl}/public/activar-usuario`, request);
  }

  solicitudRestablecerPassword(request: SolicitudRestablecerPasswordRequest): Observable<string> {
    return this.http.post(`${this.baseUrl}/public/solicitud-restablecer-password`, request, { responseType: 'text' });
  }

  restablecerPassword(request: RestablecerPasswordRequest): Observable<string> {
    return this.http.put(`${this.baseUrl}/public/restablecer-password`, request, { responseType: 'text' });
  }

  isCodigoRestablecerPasswordValido(codigo: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}/public/is-codigo-restablecer-password-valido/${codigo}`);
  }

  desactivarUsuario(id: number): Observable<boolean> {
    return this.http.put<boolean>(`${this.baseUrl}/desactivar/${id}`, {});
  }
}
